export function joinUrl(...parts: string[]): string {
  // remove leading and trailing slashes before joining with a single slash
  return parts.map((part) => part.replaceAll(/^\/|\/$/g, '')).join('/');
}
